import { render } from "./Limits.vue?vue&type=template&id=1c2e5b4c&scoped=true"
import script from "./Limits.vue?vue&type=script&lang=js"
export * from "./Limits.vue?vue&type=script&lang=js"

import "./Limits.vue?vue&type=style&index=0&id=1c2e5b4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c2e5b4c"]])

export default __exports__